async function get(url) {
  const response = await fetch(url, { headers: { accept: 'application/json' } });
  if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
  return response.json();
}

export const fetchVideos = () => get('/api/videos').then((data) => data.videos);
export const fetchVideo = (id) => get(`/api/videos/${encodeURIComponent(id)}`);
export const fetchIncoming = () => get('/api/incoming').then((data) => data.pending);
